<template>
    <div>
        <h1>Работа с поисковой строкой</h1>

        <h2>Точная формулировка</h2>

        <p>
            Если необходимо осуществить поиск по конкретной фразе,
            состоящей из нескольких слов, <br>
            то данную фразу необходимо обернуть в двойные кавычки - <strong>".</strong>
        </p>
        <p><i>Например, “аналитик баз данных”.</i></p>

        <h2>Операторы</h2>

        <p><strong>Символ пробела</strong> - обязательное присутствие значений (соединенных пробелом) единовременно в одном поле</p>
        <p><strong>AND</strong> или <strong>&&</strong> - обязательное присутствие соединяемых значений в разных полях</p>
        <p><strong>OR</strong> или <strong>||</strong> - присутствие хотя бы одного из значений в каком-либо поле</p>
        <p><strong>NOT</strong> или <strong>!</strong> (перед словом/фразой/группой) - отсутствие определенного значения / группы условий</p>

        <p>Примеры</p>
        <ul>
            <li>
                <p>
                    <strong>россия страна возможностей</strong> (порядок слов значения не имеет) - будет произведен <br>
                    поиск "составной фразы" (всех возможных сочетаний) из слов "россия", "страна" и "возможностей" <br>
                    в рамках одного поля и, скорее всего, будут найдены результаты в рамках поля названия организации
                </p>
            </li>
            <li>
                <p>
                    <strong>Аналитик AND сбербанк</strong> - будет произведен поиск слов "аналитик" и "сбербанк" <br>
                    в рамках разных полей (и должно быть хотя бы по одному вхождению по каждому из них в каком-либо поле).
                    <br>
                    В результате ожидается что "Аналитик" может быть найден в поле должности, а "сбербанк" - названии организации.
                </p>
                <p>
                    Если же произвести поиск без оператора AND - <strong>Аналитик сбербанк</strong> - <br>
                    будет произведен поиск слов "аналитик" и "сбербанк" в рамках только "одного" поля <br>
                    (т.е. будет произведен поиск "составной фразы")
                </p>
            </li>
        </ul>

        <h2>Поиск по полю</h2>

        <p>
            Для осуществления запроса по конкретному полю необходимо <br>
            использовать конструкцию вида <strong>имя_поля: слово</strong>
        </p>
        <p>
            При необходимости использования более одного слова - <br>
            необходимо использовать либо группировку, либо поиск по точному вхождению <br>
            <strong>имя_поля: (слово1 слово2 слово3)</strong> <br>
            <strong>имя_поля:"слово1 слово2 слово3"</strong>
        </p>

        <h3>Допустимые поля</h3>
        <ul>
            <li><strong>user_id</strong> - id пользователя (только целочисленные значения!)</li>
            <li><strong>fullname</strong> - ФИО</li>
            <li><strong>name</strong> - имя</li>
            <li><strong>surname</strong> - фамилия</li>
            <li><strong>patronymic</strong> - отчество</li>
            <li><strong>about</strong> - поле "обо мне"</li>
            <template v-if="hasUserContactsAccess">
                <li><strong>email</strong> - контактный email</li>
                <li><strong>reg_email</strong> - регистрационный email</li>
                <li><strong>phone</strong> - контактный телефон</li>
                <li><strong>reg_phone</strong> - регистрационный телефон</li>
            </template>
        </ul>

        <div><strong>Карьера</strong></div>
        <ul>
            <li><strong>organization</strong> - название организации</li>
            <li><strong>position</strong> - должность</li>
            <li><strong>responsibilities</strong> - обязанности</li>
        </ul>

        <div><strong>Образование</strong></div>
        <ul>
            <li><strong>faculty</strong> - факультет</li>
            <li><strong>education_place</strong> - название учебного заведения</li>
            <li><strong>foreign_place</strong></li>
            <li><strong>comments</strong> - комментарий администратора</li>
        </ul>

        <h2>Группировка</h2>

        <p>
            Для создания более сложных запросов и осуществления группировки можно использовать <br>
            круглые скобки - <strong>(</strong> и <strong>)</strong> - для обозначения группы условий.
        </p>
        <p>
            Например, <br>
            <strong>(аналитик OR (Менеджер продукта)) AND (Газпром OR сбербанк)</strong>
        </p>
        <p>
            Если перед группой поставить оператор поля, то поиск данных этой группы будет произведен только в указаном поле <br>
            <strong>position:(аналитик OR (Менеджер продукта)) AND organization:(Газпром OR сбербанк)</strong>
        </p>
    </div>
</template>
<script>
import {mapGetters} from "vuex";

export default {
    name: 'UserSearchHelp',

    computed: {
        ...mapGetters('auth', [
            'hasUserContactsAccess',
        ]),
    },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/rem";
@import "~@/styles/variables";

#kitty {
    display: block;
    margin: 0 auto;
    max-width: 100%;
    width: 100%;

    @include  on-desktop {
        width: rem(500);
    }
}
</style>
